export default () => ({

    swiper: null,

    init: function () {

        // noinspection JSUnresolvedReference
        this.swiper = new Swiper(this.$root.querySelector('.swiper'), {
            direction: 'horizontal',
            loop: false,
            slidesPerView: 1,
            spaceBetween: 20,
            // autoplay: {
            //     delay: 5000,
            // },
            pagination: {
                el: '.swiper-pagination',
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 3,
                }
            }
        });

    }

});
